<template>
  <div class="custom-control custom-switch">
    <p class="mb-0 font-medium font-12" style="margin-left:-51px;">{{ topLabel }}</p>
    <input type="checkbox" :id="id" class="custom-control-input" :disabled="disabled" :checked="value" @change="$emit('change', $event.target.checked)">
    <label :for="id" class="custom-control-label switch-label d-inline-block">{{ label }}</label>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid';

export default {
  name: 'Onoff',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    topLabel: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      id: null
    };
  },
  created() {
    this.id = uuid();
  }
};
</script>
